import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal } from '@weezevent/nacre';

import Style from '../../moderationProfile.module.css';

export default function ModerationProfileAttachmentsFullscreenModal({ open, index, file, extension, setOpenModal, title }) {
    const { t } = useTranslation();

    return (
        <Modal
            size="fullscreen"
            open={open}
            onClose={() => setOpenModal(false)}
            title={title}
            allowExternalClosing={false}
            cancelButton={<Button label={t('ticket.common.action.back')} onClick={() => setOpenModal(false)} />}
            className={Style['attendee-attachments-modal']}
        >
            {extension === 'pdf' ? (
                <div className={Style['attendee-attachments-pdf-modal']}>
                    <iframe title={`pdf_attachment_full_screen_${index}`} className={Style['attendee-attachments-pdf-full']} src={`${file}#toolbar=0&navpanes=0`} />
                </div>
            ) : (
                <img className={Style['attendee-attachments-img-modal']} src={file} alt="" />
            )}
        </Modal>
    );
}
